export enum EForeignCurrency {
  EUR = 'EUR',
  USD = 'USD',
  CHF = 'CHF',
  GBP = 'GBP',
  AUD = 'AUD',
  PLN = 'PLN',
  CAD = 'CAD',
  DKK = 'DKK',
  SEK = 'SEK',
  HUF = 'HUF',
  HRK = 'HRK',
  CZK = 'CZK',
  MAD = 'MAD',
  TRY = 'TRY',
  NOK = 'NOK',
  RON = 'RON',
  BGN = 'BGN',
  JOD = 'JOD',
  EGP = 'EGP',
  RUB = 'RUB',
  TND = 'TND',
  ISK = 'ISK',
  SAR = 'SAR',
  RSD = 'RSD',
  KZT = 'KZT',
  AZN = 'AZN',
}

export const ForeignCurrencyValues = Object.values(EForeignCurrency)
